import { render, staticRenderFns } from "./LetbaneLogo.vue?vue&type=template&id=166852d8&scoped=true&"
import script from "./LetbaneLogo.vue?vue&type=script&lang=js&"
export * from "./LetbaneLogo.vue?vue&type=script&lang=js&"
import style0 from "./LetbaneLogo.vue?vue&type=style&index=0&id=166852d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166852d8",
  null
  
)

export default component.exports